export default __webpack_public_path__ + "static/media/steps.1829fbe9.svg";